/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Not_FoundInputs */

const en_us2_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't find this exercise.`)
};

const pt_br2_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontramos esse exercício.`)
};

const es_419_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No encontramos este ejercicio.`)
};

const pt_pt2_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontrámos este exercício.`)
};

const fr_fr2_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice introuvable.`)
};

const de_de2_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung haben wir nicht gefunden.`)
};

const it_it2_exercise_not_found = /** @type {(inputs: Exercise_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non abbiamo trovato questo esercizio.`)
};

/**
* | output |
* | --- |
* | "We couldn't find this exercise." |
*
* @param {Exercise_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_not_found = /** @type {((inputs?: Exercise_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_not_found(inputs)
	if (locale === "es-419") return es_419_exercise_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_not_found(inputs)
	if (locale === "de-DE") return de_de2_exercise_not_found(inputs)
	if (locale === "it-IT") return it_it2_exercise_not_found(inputs)
	return en_us2_exercise_not_found(inputs)
});
export { exercise_not_found as "exercise.not_found" }